export var UFOGlobalEventStreamEventType = /*#__PURE__*/function (UFOGlobalEventStreamEventType) {
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
  return UFOGlobalEventStreamEventType;
}({});
export var PageVisibleState = /*#__PURE__*/function (PageVisibleState) {
  PageVisibleState["VISIBLE"] = "visible";
  PageVisibleState["HIDDEN"] = "hidden";
  PageVisibleState["MIXED"] = "mixed";
  return PageVisibleState;
}({});
export var PageLoadMetrics = /*#__PURE__*/function (PageLoadMetrics) {
  PageLoadMetrics["fmp"] = "fmp";
  PageLoadMetrics["tti"] = "tti";
  return PageLoadMetrics;
}({});
export var PageSegmentLoadMetrics = /*#__PURE__*/function (PageSegmentLoadMetrics) {
  PageSegmentLoadMetrics["fmp"] = "fmp";
  PageSegmentLoadMetrics["tti"] = "tti";
  return PageSegmentLoadMetrics;
}({});
export var InteractionMetrics = /*#__PURE__*/function (InteractionMetrics) {
  InteractionMetrics["response"] = "response";
  InteractionMetrics["result"] = "result";
  return InteractionMetrics;
}({});
export var CustomMetrics = /*#__PURE__*/function (CustomMetrics) {
  CustomMetrics["duration"] = "duration";
  return CustomMetrics;
}({});
export var SUBSCRIBE_ALL = '__SUBSCRIBE_ALL__';
export var FMP_MARK = 'fmp';
export var INLINE_RESPONSE_MARK = 'inline-response';